import { isTelegramBotPath } from "@/lib/telegram/telegramPaths";

export { isTelegramBotPath };

/** Community Signal SEO article: full-width read; do not auto-open the shell sidebar. */
export function isCommunitySignalTokenPagePath(pathname) {
  if (!pathname || typeof pathname !== "string") return false;
  return /^\/community\/[^/]+\/token\/[^/]+\/?$/.test(pathname);
}

/** Embeddable AI support widget — no site chrome; iframe-only surface. */
export function isSupportWidgetPath(pathname) {
  if (!pathname || typeof pathname !== "string") return false;
  return (
    pathname === "/support-widget" || pathname.startsWith("/support-widget/")
  );
}

/** AI Coin Lab chat app — own chrome; no Tools sidebar/header shell. */
export function isAiCoinLabPath(pathname) {
  if (!pathname || typeof pathname !== "string") return false;
  const cleaned = pathname.split("?")[0].split("#")[0];
  const normalized =
    cleaned.length > 1 && cleaned.endsWith("/") ? cleaned.slice(0, -1) : cleaned;
  return (
    normalized === "/ai/coin-lab" || normalized.startsWith("/ai/coin-lab/")
  );
}

/** Dashboard: full-width bot grid; keep the shell sidebar closed on entry. */
export function isDashboardPath(pathname) {
  if (!pathname || typeof pathname !== "string") return false;
  return pathname === "/dashboard" || pathname.startsWith("/dashboard/");
}

/** Routes that should not reserve left shell margin or auto-open the sidebar. */
export function isFullWidthShellPath(pathname) {
  return (
    isDashboardPath(pathname) ||
    isCommunitySignalTokenPagePath(pathname) ||
    isTelegramBotPath(pathname) ||
    isSupportWidgetPath(pathname) ||
    isAiCoinLabPath(pathname)
  );
}
